import React from 'react';

function Error() {
  return (
    <div className="container-custom">
      <div className="row">
        <div className="col-lg-12 text-center" style={{ paddingTop: '100px' }}>
          <h1 className="error-404">404</h1>
          <p>Page not found</p>
          <a href="/home" className="btn btn-primary">Go Home</a>
        </div>
      </div>
    </div>
  );
}

export default Error;
